import { render, staticRenderFns } from "./infoSetAdditionalParams.vue?vue&type=template&id=4ce3cc84&scoped=true"
import script from "./infoSetAdditionalParams.vue?vue&type=script&lang=js"
export * from "./infoSetAdditionalParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3cc84",
  null
  
)

export default component.exports